import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Flex, Text, ButtonFilled, Image } from '../../Base';
import { SPACE } from '../../Theme';
import withConfig from '../../../Context/ConfigContext/hoc';

const MainBox = styled(Flex)`
  height: 100vh;
`;

const NoMatchPaaS = ({
  onButtonClick,
  appConfig: {
    classroom: { defaultOwnerLogoUrl },
  },
}) => {
  return (
    <MainBox flexDirection="column" justifyContent="center" alignItems="center" p={SPACE.lg}>
      <Image src={defaultOwnerLogoUrl} />
      <Text fontWeight="medium" textAlign="center" mt={4}>
        Error 404: We cannot seem to find the page you are looking for.
      </Text>
      <Box mt={4}>
        <ButtonFilled onClick={onButtonClick}>Go back to homepage!</ButtonFilled>
      </Box>
    </MainBox>
  );
};

NoMatchPaaS.propTypes = {
  onButtonClick: PropTypes.func,
  appConfig: PropTypes.shape({
    classroom: PropTypes.shape({
      defaultOwnerLogoUrl: PropTypes.string,
    }),
  }),
};

NoMatchPaaS.defaultProps = {
  onButtonClick: () => {},
};

export default withConfig(NoMatchPaaS);
